import classNames from 'classnames';

import truncate from '@shared/helpers/web3/truncate';

import { Ticket as TicketIcon } from '@ui/uikit/components/icons/mono';

type Props = {
  code: string;
  isWinner: boolean;
};

export const RewardPoolTicket = ({ code, isWinner }: Props) => {
  return (
    <div className="flex gap-1.5 items-center">
      <TicketIcon
        className={classNames(
          'w-4 h-4 flex-shrink-0 text-caption-sm-mono-a',
          isWinner ? 'text-base-text-orange' : 'text-base-text-quaternary',
        )}
      />
      <span className="text-base-text-primary text-caption-sm-a truncate">
        {truncate(code, { start: 4, end: 4 })}
      </span>
    </div>
  );
};
